import script from "./Projetos.vue?vue&type=script&setup=true&lang=js"
export * from "./Projetos.vue?vue&type=script&setup=true&lang=js"

import "./Projetos.css?vue&type=style&index=0&id=4486bfcf&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4486bfcf"]])

export default __exports__